import {ResultType} from '@remix-run/router/dist/utils';
import {fetch} from '@app/apiFunction';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import {BASE_URL} from '../config';

export const getTodayDaily = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/dailies/get-daily`;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getTodayLogUpdates = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/task/today-timespent`;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getTodayLogTime = async (
  startDate: string,
  endDate: string,
  userId: string
) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/task/today-timespent?startDate=${startDate}&endDate=${endDate}&userId=${userId}`;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const saveDailyGoals = async (data: any) => {
  const payload = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = `${BASE_URL}/dailies/create`;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const updateDailies = async (data: any, dailyId: string | null) => {
  const payload = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = `${BASE_URL}/dailies/update/${dailyId}`;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const getAllDailies = async (query: {[key: string]: any}) => {
  const requestQuery = Object.keys(query)
    .filter((v: string) => {
      // console.log(v,"key")
      // console.log(query[v],"value")
      return query[v] !== null;
    })
    .filter((v) => query[v] !== 0)
    .map((v) => {
      // console.log(v,"v here")
      return `${v}=${query[v]}`;
    })
    .join('&');

  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/dailies/get-all-dailies?${requestQuery}`;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const DailiesAll = async (query: {[key: string]: any}) => {
  const requestQuery = Object.keys(query)
    .filter((v) => {
      // console.log(v,"key")
      // console.log(query[v],"value")
      return query[v] !== null;
    })
    .filter((v) => query[v] !== 0)
    .map((v) => {
      // console.log(v,"v here")
      return `${v}=${query[v]}`;
    })
    .join('&');
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/dailies/all-dailies?${requestQuery}`;
  const resp = fetch(url, type, null, token);
  return resp;
};
